import type { CSSProperties } from 'react';

type ScrollViewProps = { style?: CSSProperties } & Record<string, any>;

// react-custom-scrollbars hides the native scrollbar by shifting the view
// with physical negative margins, which clips RTL containers, and renders
// fallback tracks once a native scrollbar width is detectable. Render the
// view without the compensation margins, hide the native scrollbar via the
// `.scroll-view` scope (see styles/index.scss), and keep the tracks hidden.
const ScrollView = ({ style, ...props }: ScrollViewProps) => (
    <div
        {...props}
        className="scroll-view"
        style={{
            ...style,
            marginRight: 0,
            marginBottom: 0,
            scrollbarWidth: 'none',
        }}
    />
);

const HiddenTrack = ({ style, ...props }: ScrollViewProps) => (
    <div {...props} style={{ ...style, display: 'none' }} />
);

export { HiddenTrack, ScrollView };
